import { render, staticRenderFns } from "./MultiPhone.vue?vue&type=template&id=5869c35e&scoped=true&"
import script from "./MultiPhone.vue?vue&type=script&lang=js&"
export * from "./MultiPhone.vue?vue&type=script&lang=js&"
import style0 from "./MultiPhone.vue?vue&type=style&index=0&id=5869c35e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869c35e",
  null
  
)

export default component.exports